import { Component } from 'react';
import PropTypes from 'prop-types';
import I18n from 'i18n-js';
import ShareButton from '@App/components/model/share/ShareButton';
import { copyAlbumUrl } from '@App/utils/share';

export default class ShareAlbumButton extends Component {
    static propTypes = {
        reference: PropTypes.string.isRequired,
    };

    constructor(props) {
        super(props);

        this.onShare = this.onShare.bind(this);
    }

    onShare() {
        const { reference } = this.props;

        copyAlbumUrl(reference);
    }

    render() {
        const { ...props } = this.props;

        delete props.reference;

        return <ShareButton label={I18n.t('model.album.actions.share')} onShare={this.onShare} {...props} />;
    }
}
